
export default {
  name: 'ProductScore',

  props: {
    score: {
      type: Number,
      default: 0,
    },

    description: {
      type: String,
      required: true,
      default: '',
    },

    tooltipContent: {
      type: String,
      required: false,
      default: '',
    },
    mode : {
      type: String,
      default: ''
    }
  },

  computed: {
    isOneLineMode() {
      if (this.mode.includes('one-line-mode')) {
        return true;
      }
      return false;
    },
    isCircleMode() {
      if (this.mode.includes('circle-mode')) {
        return true;
      }
      return false;
    }
  }
};
